import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";

import history from "../../store/history";
import { FEEDBACK_RESPOND_URL } from "../../config";
import SubmitButton from "../button/SubmitButton";
import CancelButton from "../button/CancelButton";
import {
    showSuccessAlert,
    showErrorAlert,
    showWarningAlert,
} from "../../store/actions/alerts";
import makeApiRequest from "../../utils/axios/new-axios";

import TextField from "../formik/TextField";
import Select from "../formik/Select";

const useStyles = makeStyles((theme) => ({
    form: {
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        width: "fit-content",
    },
}));

const yupSchema = Yup.object().shape({
    comment: Yup.string().trim().required("Comment Required!"),
    status: Yup.number().min(1).max(3).integer().required(),
});

export default function FeedbackRespondForm({
    openModal,
    handleCloseModal,
    respondParams
}) {
    const dispatch = useDispatch();
    const classes = useStyles();

    async function handleSubmit(values, { setSubmitting }) {
        setSubmitting(true);

        await makeApiRequest({
            url: `${FEEDBACK_RESPOND_URL.url}/${respondParams.id}`,
            method: FEEDBACK_RESPOND_URL.method,
            data: {
                status: values.status,
                comments: values.comment.trim(),
            },
        })
            .then((response) => {
                if (response.data.affectedRows > 0) {
                    dispatch(showSuccessAlert('Feedback updated successfully!'));
                    //reload the same page
                    history.push(history.location.pathname);
                } else {
                    setSubmitting(false);
                    dispatch(showWarningAlert(`No changes done. But no errors!`));
                }
            })
            .catch((error) => {
                setSubmitting(false);
                dispatch(
                    showErrorAlert(
                        "Error : " +
                        (!!error.response
                            ? `${error.response.status}! - ${error.response.data.errorMessage}`
                            : error.message)
                    )
                );
            });
    }

    return (
        <Dialog
            open={openModal}
            onClose={handleCloseModal}
            fullWidth={true}
            maxWidth="sm"
            aria-labelledby="feedback-dialog-add-edit"
            aria-describedby="feedback-dialog-add-edit"
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            disableEnforceFocus={true}
        >
            <DialogTitle id="feedback-dialog-title">
                Update Feedback
            </DialogTitle>
            <Formik
                initialValues={{
                    comment: respondParams.comment,
                    status: respondParams.status
                }}
                onSubmit={handleSubmit}
                validationSchema={yupSchema}
            >
                {(props) => {
                    const { touched, errors, isSubmitting } = props;
                    return (
                        <Form className={classes.form}>
                            <DialogContent dividers style={{ overflow: "visible" }}>
                                <Field
                                    component={Select}
                                    name="status"
                                    label="Status *"
                                    fullWidth
                                    options={[
                                        {
                                            value: 1,
                                            label: "Responded",
                                        },
                                        {
                                            value: 2,
                                            label: "Spam",
                                        },
                                        {
                                            value: 3,
                                            label: "Other",
                                        }
                                    ]}
                                    disabled={isSubmitting}
                                />

                                <Field
                                    component={TextField}
                                    name="comment"
                                    margin="dense"
                                    label="Comment *"
                                    fullWidth
                                    helperText={touched.comment && errors.comment && errors.comment}
                                    error={!!touched.comment && !!errors.comment}
                                    disabled={isSubmitting}
                                    autoFocus
                                />
                            </DialogContent>
                            <DialogActions style={{ margin: "20px" }}>
                                <CancelButton
                                    onClick={handleCloseModal}
                                    disabled={isSubmitting}
                                >
                                    Cancel
                                </CancelButton>
                                <SubmitButton
                                    disabled={isSubmitting}
                                    isSubmitting={isSubmitting}
                                    autoFocus
                                >
                                    Update
                                </SubmitButton>
                            </DialogActions>
                        </Form>
                    );
                }}
            </Formik>
        </Dialog>
    )
}
